/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".apply-info[_ngcontent-%COMP%]{background:#cbced28c;border-radius:25px;box-shadow:2px 5px 5px #a9a9a9;padding:10px}.info-head[_ngcontent-%COMP%]{text-indent:20px}#iconStyle[_ngcontent-%COMP%]{color:#232323;font-size:28px;float:left;height:50px}.coupon-code-card[_ngcontent-%COMP%]{border:1px solid #004aad;margin:15px 0}.coupon-code-card[_ngcontent-%COMP%]:hover{border-radius:25px!important;box-shadow:4px 4px 8px 0 rgba(0,0,0,.2)!important;-webkit-box-shadow:4px 4px 8px 0 rgba(0,0,0,.2)!important;-moz-box-shadow:4px 4px 8px 0 rgba(0,0,0,.2)!important;transform:scale(1)!important}"];
export { styles as styles };

